module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 Green.8d739fb1.png";